<template>
  <Table>
    <thead>
      <tr>
        <th data-cy="results">Results</th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr data-cy="results-created-warn">
        <td>Created</td>
        <td>
          {{ results.created }}
        </td>
        <td>Warn</td>
        <td>
          {{ results.warn }}
        </td>
      </tr>
      <tr data-cy="results-updated-error">
        <td>Updated</td>
        <td>
          {{ results.updated }}
        </td>
        <td>Error</td>
        <td :class="{ 'text-danger': results.error }" data-cy="results-error">
          {{ results.error }}
        </td>
      </tr>
      <tr data-cy="results-deleted-fatal">
        <td>Deleted</td>
        <td>
          {{ results.deleted }}
        </td>
        <td>Fatal</td>
        <td :class="{ 'text-danger': results.fatal }">
          {{ results.fatal }}
        </td>
      </tr>
      <tr data-cy="results-ignored">
        <td>Ignored</td>
        <td>
          {{ results.ignored }}
        </td>
        <td></td>
        <td></td>
      </tr>
      <tr data-cy="results-unchanged">
        <td>Unchanged</td>
        <td>
          {{ results.unchanged }}
        </td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </Table>
</template>

<script>
import Table from "@/components/Table.vue";
export default {
  components: {
    Table
  },
  props: {
    results: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
tbody tr td:first-child {
  width: 30%;
}
</style>
